import React from "react";
import { ReactElement } from "react";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import {CaretUpSquareFill, Back } from 'react-bootstrap-icons'
import "./dashboardStatCard.scss";

interface Props<TypeStatCard> {
    title?: string;
    stats?: number | string;
    icon?: string;
    iconColor?: string;
    iconBg?: string;
    label?: string;
    onClick?: () => void;
    classes?: string;
}

export default function ClickableCards<TypeStatCard>({
    title,
    stats,
    icon,
    iconColor,
    iconBg,
    label,
    onClick,
    classes
}: Props<TypeStatCard>): ReactElement {
    return (
        <Card
            className={`card-stats mb-4 mb-xl-0 shadow-sm ${!!onClick ? "pointer" : ""
                }`}
        >
            <CardBody
                onClick={() => {
                    onClick && onClick();
                }}
            >
                <div className="d-flex justify-content-center align-items-center">
                    {icon
                        ?
                        <div
                            className={`rounded-circle shadow mr-2 ${iconColor || ""}`}
                            style={{ backgroundColor: iconBg, fontSize: 24 }}
                        >
                            <i className={icon}  />
                        </div>
                        :
                        <></>}
                       
                    {stats
                        ?
                        <div className="font-weight-bold mb-0" style={{ fontSize: 24 }}>
                            {stats || "-"}
                        </div>
                        :
                        <><Back size={28}/></>}
                </div>
                <p className=" mt-2 mb-0 text-muted small font-weight-bold text-center">
                    <span>{title}</span>
                </p>
            </CardBody>
        </Card>
    );
}
